<template>
  <div class="svg-container" @click="setupIosWidgetGenreClick">
    <svg
      t="1758082763248"
      class="icon"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="2471"
      width="200"
      height="200"
      fill="white"
    >
      <path
        d="M721.773714 166.4c55.515429-9.435429 83.273143-14.189714 101.449143 1.170286 18.176 15.36 18.176 43.52 18.176 99.803428v23.990857c0 43.483429 0 65.206857-13.019428 79.762286-12.982857 14.592-34.56 17.042286-77.750858 21.979429L310.125714 443.538286c-44.544 5.12-66.816 7.643429-81.408-5.046857s-15.140571-35.108571-16.310857-79.908572l-0.731428-28.781714c-0.950857-36.242286-1.389714-54.345143 8.996571-66.998857 10.386286-12.653714 28.233143-15.689143 64-21.796572l437.101714-74.605714zM354.048 534.528c55.881143-5.485714 83.785143-8.192 101.668571 8.045714 17.883429 16.164571 17.883429 44.251429 17.883429 100.352v122.660572c0 41.984 0 62.976-13.092571 75.849143-13.129143 12.909714-34.121143 12.580571-76.068572 11.885714l-65.755428-1.024c-50.176-0.804571-75.264-1.206857-90.88-16.932572-15.652571-15.725714-15.872-40.813714-16.310858-90.989714l-0.877714-96.036571c-0.438857-47.36-0.658286-71.021714 13.531429-86.784 14.116571-15.725714 37.668571-18.029714 84.809143-22.637715l45.092571-4.388571zM766.464 704c34.304-2.377143 51.456-3.584 63.744 4.388571 4.315429 2.816 8.118857 6.363429 11.227429 10.496 8.777143 11.702857 8.777143 28.891429 8.777142 63.268572 0 33.133714 0 49.737143-8.338285 61.257143-2.962286 4.059429-6.582857 7.606857-10.752 10.422857-11.776 8.045714-28.342857 7.570286-61.44 6.656l-130.011429-3.730286c-25.6-0.731429-38.4-1.097143-47.945143-6.582857a43.885714 43.885714 0 0 1-16.749714-17.225143c-5.266286-9.764571-5.266286-22.564571-5.266286-48.128 0-24.649143 0-36.973714 4.973715-46.518857a43.885714 43.885714 0 0 1 15.981714-17.115429c9.142857-5.632 21.467429-6.473143 46.08-8.192l129.718857-8.996571zM784.969143 632.466286c30.427429-2.779429 45.641143-4.205714 55.076571-14.043429l1.28-1.389714c8.923429-10.313143 8.923429-25.6 8.923429-56.100572 0-37.266286 0-55.881143-11.593143-66.706285a38.144 38.144 0 0 0-1.645714-1.462857c-12.178286-10.130286-30.646857-7.789714-67.620572-3.145143l-144.896 18.249143c-21.540571 2.706286-32.329143 4.022857-40.045714 9.801142a36.571429 36.571429 0 0 0-9.984 11.337143c-4.754286 8.411429-4.754286 19.236571-4.754286 40.96 0 31.744 0 47.616 7.460572 58.697143a43.885714 43.885714 0 0 0 15.396571 14.043429c11.739429 6.436571 27.538286 4.973714 59.172572 2.048l133.229714-12.288z"
        p-id="2472"
      ></path>
    </svg>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      genre: "getGenre",
    }),
  },

  methods: {
    setupIosWidgetGenreClick() {
      console.log("setupIosWidgetGenreClick", this.genre);
      const genreInfo = {
        genre: this.genre,
      };
      window.parent.postMessage(JSON.stringify(genreInfo), "*");
    },
  },
};
</script>

<style scoped>
.svg-container {
  /* display: inline-block; */
  /* position: fixed;
  right: 0;
  top: 0; */
  width: 56px;
  height: 56px;
  /* z-index: 250; */
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
}

.svg-container .icon:active {
  fill: #d8d8d8;
}

svg {
  /* width: 26px; */
  height: 26px;
  /* position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0; */
  margin: auto;
}
</style>
